<template>
  <ContentSection
    v-if="groups.length !== 0"
    id="suitable-products"
    color-mode="dark"
  >
    <HeadlineBlock
      :headline="headline"
      :cols="8"
      :cols-centered="true"
      :content-centered="true"
    />
    <TabsComponent
      id="related-products-tab"
      tab-list-position="top"
      :tab-list-is-fullwidth="false"
    >
      <TabPanel
        v-for="(group, index) in groups"
        :key="group.title"
        :uid="group.tabId"
        :title="$textDictionary[group.groupTitle] ?? group.groupTitle"
        :active-on-init="index === 0"
      >
        <LazyLoad>
          <ReloadableProductList
            :group="group"
            size="full"
            :generate-detail-link="generateDetailLink"
          />
        </LazyLoad>
      </TabPanel>
    </TabsComponent>
  </ContentSection>
</template>

<script setup lang="ts">
import {
  ContentSection,
  HeadlineBlock,
  TabPanel,
  TabsComponent
} from '@hypercodestudio/basler-components';
import ReloadableProductList from './ReloadableProductList.vue';
import { useProductDetailPageStore } from '~/stores/productDetailPageStore/productDetailPageStore';
import type { DecoratedProduct } from '~/utils/shop/DecoratedProduct';
import LazyLoad from '~/components/lib/LazyLoad.vue';

type Props = {
  generateDetailLink: (p: DecoratedProduct) => string;
};
defineProps<Props>();

const store = useProductDetailPageStore();
const { $textDictionary } = useNuxtApp();
const specificationConfiguration = usePdpConfiguration();

const groups = computed(() => {
  if (!specificationConfiguration.value) {
    return [];
  }

  return (
    store.decoratedProduct
      ?.getGroupedRelatedProducts(specificationConfiguration.value)
      .filter((item) => item.products.length > 0) ?? []
  );
});

const headline = computed(() => {
  return {
    content: $textDictionary.value['pdp.relatedproducts.title'],
    level: 2
  };
});
</script>
